import { createFileRoute } from '@tanstack/react-router';

import { SiteCoursesPage } from '@/features/owner/site/SiteCoursesPage';

export const Route = createFileRoute('/_authed/owner/site/courses')({
  component: SiteCoursesPage,
});
